import { request } from '@/api/index';
import { GetTravelStandardRewardRule } from '@/api/hotel/index';
import app from '@/common/public.js';
export default {
  namespaced: true,
  state: {
    hotelDetailInfo: {}, //酒店列表进入详情数据
    backFromRemarkPage: false, //是否从点评页返回的酒店详情
    // 节省奖励规则信息
    savingBonusRuleInfo: {
      Remark: '',
      Rules: [],
    },
  },
  getters: {
    savingBonusRuleInfo: (state) => state.savingBonusRuleInfo || {},
    //所选的奖励节省选项
    savingBonusselectedList: (state) => (state.savingBonusRuleInfo.Rules || []).filter((f) => f.IsSelected),
  },
  mutations: {
    // 存储酒店详情信息
    setHotelDetailInfo(state, data) {
      state.hotelDetailInfo = data || {};
    },
    // 设置点评返回页
    setBackFromRemarkPage(state, data) {
      state.backFromRemarkPage = data || false;
    },
    // 存储节省奖励规则信息
    setsavingBonusRuleInfo(state, data) {
      state.savingBonusRuleInfo = data || {};
    },
    // 选择奖励节省选项
    setSavingBonus(state, data) {
      state.savingBonusRuleInfo.Rules = data || [];
    },
  },
  actions: {
    // 选择奖励节省规则信息
    getSavingBonusRule({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        request({ apiName: GetTravelStandardRewardRule, params: { DestCode: data } })
          .then((res) => {
            commit('setsavingBonusRuleInfo', res.Data || { Rules: [] });
            resolve(res);
          })
          .catch((err) => {
            reject(err.Msg);
          });
      });
    },
  },
};
